import avatarModal from './avatarModal'

const zhCN = { 
  tabAccountSettings: '账户设置',

  avatarTitle: '账户头像',
  ...avatarModal.zhCN,
  setAvatarSuccess: '设置账户头像成功！',
  setAvatarFail: '设置账户头像失败！',

  accountInfoTitle: '账户信息',
  unitName: '单位名称',
  unitNameBlank: '请填写单位名称！',
  unitNameWarning: '单位名称最多40字！',

  phone: '绑定手机号',
  changePhone: '修改绑定手机号',
  changePhoneTxt: '新手机号',
  changePhoneWarning: '请输入正确的手机号码！',

  submitAccountInfoBtn: '提交信息',

  changeAccountInfoSuccess: '修改账户信息成功！',
  changeAccountInfoFail: '修改账户信息失败！'
}
const enUS = {
  tabAccountSettings: 'Account Settings',

  avatarTitle: 'Account Avatar',
  ...avatarModal.enUS,
  setAvatarSuccess: 'Set the account avatar successfully!',
  setAvatarFail: 'Set the account avatar Failed!',

  accountInfoTitle: 'Account Info',
  unitName: 'Organization',
  unitNameBlank: 'Organization name can\'t be blank!',
  unitNameWarning: 'Organization is up to 40 words!',

  phone: 'Phone',
  changePhone: 'Change Phone',
  changePhoneTxt: 'New phone',
  changePhoneWarning: 'Please enter the correct cell phone number!',

  submitAccountInfoBtn: 'Submit Info',

  changeAccountInfoSuccess: 'Change the account info successfully!',
  changeAccountInfoFail: 'Change the account info failed!'
}

export default { zhCN, enUS }